import { useRef, useState, useEffect } from "react";
import "../styles/intro-video.css";

const IntroVideo = () => {
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);
  const [isZaloIOS, setIsZaloIOS] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    // Detect Zalo iOS
    const ua = navigator.userAgent.toLowerCase();
    const zaloIOS =
      ua.includes("zalo") &&
      (ua.includes("iphone") || ua.includes("ipad") || ua.includes("ipod"));
    setIsZaloIOS(zaloIOS);

    if (!zaloIOS) {
      const video = videoRef.current;
      if (!video) return;

      const handleLoaded = () => {
        video.classList.add("loaded");
        video.muted = isMuted;
        video
          .play()
          .then(() => setIsPlaying(true))
          .catch(() => {
            console.warn("Autoplay failed");
          });
      };

      video.addEventListener("loadeddata", handleLoaded);
      return () => {
        video.removeEventListener("loadeddata", handleLoaded);
      };
    }
  }, [isMuted]);

  const handleTogglePlay = () => {
    const video = videoRef.current;
    if (!video) return;

    if (video.paused) {
      video
        .play()
        .then(() => setIsPlaying(true))
        .catch(() => {});
    } else {
      video.pause();
      setIsPlaying(false);
    }
  };

  const handleToggleMute = () => {
    const video = videoRef.current;
    if (!video) return;
    const newMuted = !video.muted;
    video.muted = newMuted;
    setIsMuted(newMuted);
  };

  return (
    <div className="intro-video-background">
      <div className="intro-video-wrapper">
        {!isZaloIOS && (
          <video
            ref={videoRef}
            className="intro-video-player"
            autoPlay
            loop
            playsInline
            muted={isMuted}
            poster="/images/banner-fallback.png"
            onClick={handleTogglePlay}
          >
            <source
              src="/videos/ccqg-2026.mp4"
              type="video/mp4"
            />
            Trình duyệt của bạn không hỗ trợ video.
          </video>
        )}

        {isZaloIOS && (
          <div className="intro-video-fallback">
            <img
              src="/images/banner-fallback.jpg"
              alt="Banner"
              className="intro-video-fallback-img"
            />
            <button
              className="intro-video-play-button"
              onClick={handleTogglePlay}
            >
              ▶ Xem video
            </button>
            <video
              ref={videoRef}
              className="hidden-video"
              playsInline
              muted={isMuted}
              loop
            >
              <source
                src="/videos/ccqg-2026.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        )}

        {!isZaloIOS && <div className="intro-video-overlay" />}

        <button
          className="intro-mute-toggle-button"
          onClick={handleToggleMute}
          aria-label={isMuted ? "Bật tiếng" : "Tắt tiếng"}
        >
          {isMuted ? "🔇" : "🔊"}
        </button>
      </div>
    </div>
  );
};

export default IntroVideo;
